export default {
    url: 'power-preparedness',
    include: ['us'],
};
